const GENERAL = {
  logout: 'Log Out',
  my_account: 'My Account',
  email: 'E-Mail',
  login: 'Log In',
  password: 'Password',
  enter_credentials: 'Enter please your Credentials',
  welcome_message: 'Hello, {name}',
  how_are_you: 'How are you today?',
  and: 'And',
  or: 'Or',
  no_result: 'No Results found',
  attribute: 'Attribute|Attributes',
  add_to_cart: 'Add To Cart',
  amount: 'Amount',
  color: 'Color',
  area: 'Area',
  close: 'Close',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  update: 'Update',
  contact_person: 'Contact Person',
  street: 'Street',
  street_additional: 'Street Additional (Etage, Apartment, etc.)',
  city: 'City',
  zip_code: 'ZIP Code',
  country: 'Country',
  firstname: 'First Name',
  lastname: 'Last Name',
  company: 'Company',
  language: 'Language',
  delivery_address: 'Delivery Address|Delivery Addresses',
  your_profile: 'Your Profile',
  back: 'Back',
  general: 'General',
  yes: 'Yes',
  no: 'No',
  next: 'Next',
  notes: 'Notes',
  your_data: 'Your data',
  address: 'Address',
  details: 'Details',
  created_at: 'Created at',
  recent_user: 'Recent User',
  recent_user_requests: 'Recent User Requests',
  user_requests: 'User Requests',
  username: 'Username',
  general_config: 'Settings',
  salution: 'Salution',
  submit: 'Submit',
  phone: 'Phone',
  user: 'User',
  active: 'Active',
  inactive: 'Inactive',
  files: 'File|Files',
  print: 'Print',
  no_files: 'No sheets available',
  news: 'News',
  recent_cart_requests: 'Recent Requests',
  recent_cart_orders: 'Recent Orders',
  more: 'More',
  name: 'Name',
  mr: 'Mr',
  ms: 'Ms',
  divers: 'X',
  orders: 'Orders',
  requests: 'Requests',
  customer: 'Customer',
  interestedParty: 'Prospect',
  other_information: 'Additional information',
  reject: 'Reject',
  confirm: 'Confirm',
  done: 'Done',
  add_new_address: 'Add new address',
  address_added: 'Address was created',
  add_contact_person: 'Please specify contact person',
  add_streetname: 'Please indicate street',
  add_postcode: 'Please enter zip code',
  add_city: 'Please specify city',
  add_country: 'Please indicate country',
  add_company: 'Please indicate company',
  nothing_found: 'Sorry, nothing found',
  not_registered_yet: 'Not registered yet?',
  login_failed: 'Login failed',
  add_user: 'Add user',
  actions: 'Actions',
  status: 'Status',
  last_request_deleted: 'The last request was deleted',
  leave_empty: 'Leave empty for automatic creation',
  reset_filter: 'Reset filter',
  loading: 'Loading',
  no_products: 'no products',
  scan_for_articlenumber: 'Scan the QR-Code',
  total_weight: 'Total weight',
  further_informations: 'Further information',
  forgot_password: 'Forgot password?',
  forgot_password_message: 'When you forgot your password, you can reset it here.',
  reset_password_message: 'Please provide your new password.',
  admin: 'Admin Section',
  share: 'Share',
  user_details: 'User Details',
  reset_email: 'Should a "Reset password email" be sent?',
  please_confirm: 'Please confirm',
  reset_password: 'Reset Password',
  password_change: 'Change password',
  street_and_housenumber: 'Street and House Number',
  back_to_app: 'Back to app',
  percentage: 'Percentage',
  qcvsand: 'Quarz sand',
  add_flake: 'Add Flake',
  add_sand: 'Add Sand',
  flakes: 'Flakes',
  request: 'Request',
  selection: 'Selection',
  add_: 'Add',
  mixing_ratio: 'Mixing Ratio',
  preview: 'Preview',
  remarks: 'Remarks',
  groundcolor: 'Base color',
  type: 'Type',
  mixer_requests: 'Mixer Requests',
  remove: 'Remove',
};

export default GENERAL;
